module.exports = __webpack_public_path__ + "static/img/MXLD_H5.cbdfcd1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/MXLD_H5.png
// module id = 69Qn
// module chunks = 34